import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FAQSection from "../components/FAQSection";
import { Helmet } from "react-helmet";
const supplierLogos = [
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfXEJ5BIB0ux1aFPg9ke9AFdV4LIqP-1IchQ&s", alt: "eBay", link: "https://www.ebay.com" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU5kj1zdQC0x-zJSS0rfoYv9SBvwYUfJ6mLH7hDBn6toRokK6ASGGRiGJbURukYJ_3Q-0&usqp=CAU", alt: "Euro Car Parts", link: "https://www.eurocarparts.com" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpC1B6aXonlYZOE4cCphUiEkju8y_5dvDX1W1rGw98Hz3ASwQsZ4y5mnuaoNMln59Ou1M&usqp=CAU", alt: "Brembo", link: "https://www.brembo.com" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZDKleFLrUAc1L8ChjBnRajpfvLxIRlmOCPkOkePwX6W42F78C8IgS0TMjsnkKgy8ngRo&usqp=CAU", alt: "GSF Car Parts", link: "https://www.gsfcarparts.com" },
    { src: "https://svacarparts.co.uk/image/catalog/sva-logo.png", alt: "SVA", link: "https://www.svaparts.com" },
];

const PartsProcurement = () => {
    useEffect(() => {
        document.title = "How to Get Cheap Parts for Garage | MM Auto Tech";

        const metaDesc = document.querySelector("meta[name='description']");
        const description =
            "Learn how to get cheap parts for your garage with MM Auto Tech. Find affordable auto components, tools, engines, tyres, and more from trusted suppliers.";

        if (metaDesc) {
            metaDesc.setAttribute("content", description);
        } else {
            const meta = document.createElement("meta");
            meta.name = "description";
            meta.content = description;
            document.head.appendChild(meta);
        }
    }, []);
    const PartsProcurementFAQs = [{
        q: "What is MM AutoTech’s parts procurement service?",
        a:
            "We source high-quality OEM and aftermarket parts from trusted suppliers across the UK, ensuring garages get reliable components quickly and at competitive rates.",
    },
    {
        q: "Who can use this service?",
        a:
            "Independent garages, dealerships, and fleet operators across the UK.",
    },
    {
        q: "Do you only supply OEM parts?",
        a:
            "No. We provide both OEM and aftermarket options, depending on your needs and budget.",
    },
    {
        q: "How do I request parts procurement?",
        a:
            "Simply contact us through our website or request a procurement quote. We’ll source the required parts and provide options.",
    },
    {
        q: "Can you source rare or specialist parts?",
        a:
            "Yes, we specialize in engines, transmissions, and hard-to-find components.",
    },
    {
        q: "What information do I need to provide when ordering?",
        a:
            "You’ll need the vehicle’s make, model, year, VIN (if available), and the specific parts required.",
    },
    {
        q: "How do you keep parts affordable?",
        a:
            "We work with multiple suppliers, allowing us to compare prices and secure the most competitive deals.",
    },
    {
        q: "Do you offer bulk purchase discounts?",
        a: "Yes, we can negotiate discounts for bulk or frequent orders.",
    },
    {
        q: "What payment methods do you accept?",
        a:
            "Bank transfer, credit/debit cards, and account-based payments for regular clients.",
    },
    {
        q: "How long does delivery take?",
        a:
            "Standard parts are usually delivered within 1–3 business days. Specialist items may take longer depending on supplier availability.",
    },
    {
        q: "Do you offer same-day delivery?",
        a:
            "Yes, for certain parts and locations within the UK. Contact us for urgent orders.",
    },
    {
        q: "Can I track my order?",
        a: "Yes, we provide tracking information once your order is dispatched.",
    },
    {
        q: "What is your return policy?",
        a:
            "Unused parts in original packaging can be returned within a set timeframe. Certain specialist items may have restrictions.",
    },
    {
        q: "Do parts come with a warranty?",
        a:
            "Yes. OEM and aftermarket parts include manufacturer warranties, which vary by supplier.",
    },
    {
        q: "What happens if the part is faulty or incorrect?",
        a:
            "We’ll arrange a replacement or refund according to the supplier’s warranty and return policy.",
    },
    ];

    return (
        <><Helmet>
            <title>Parts Procurement | MM AutoTech UK</title>
            <meta
                name="description"
                content="MM AutoTech helps garages source quality parts quickly and at the best prices, reducing downtime and costs for UK garages." />
            <link rel="canonical" href="https://mmautotech.com/services/parts-procurement" />
        </Helmet><div className="max-w-7xl mx-auto space-y-24">
                {/* Hero Section */}
                <section className="flex flex-col lg:flex-row items-stretch">
                    <div className="lg:w-1/2 p-8 flex flex-col justify-center">
                        <h1 className="text-4xl font-bold mb-6 text-blue-900">
                            Reliable Parts Procurement for Garages Across the UK
                        </h1>
                        <p className="text-gray-700 mb-6">
                            At MM AutoTech, we take the hassle out of sourcing automotive parts
                            for independent garages, dealerships, and fleet operators. With
                            access to trusted suppliers and OEM-quality components, we secure
                            the parts you need—quickly, affordably, and reliably—so you can
                            focus on servicing your customers.
                        </p>
                        <Link
                            to="/contact"
                            className="inline-flex items-center justify-center text-sm font-semibold tracking-widest text-blue-900 border border-blue-900 px-6 py-2 rounded hover:bg-yellow-400 hover:border-yellow-400 transition-colors duration-300"
                        >
                            Get a Procurement Quote
                        </Link>
                    </div>
                    <div
                        className="lg:w-1/2 h-64 lg:h-auto relative overflow-hidden"
                        style={{ clipPath: "polygon(15% 0, 100% 0, 100% 100%, 0% 100%)" }}
                    >
                        <img
                            src="https://www.shutterstock.com/image-photo/modern-car-headlight-close-photo-600nw-1950050917.jpg"
                            alt="Parts Procurement Service"
                            className="w-full h-72 md:h-full rounded shadow-lg object-cover" />
                    </div>
                </section>

                {/* What We Source Section */}
                <section className="bg-blue-100 py-10 px-6">
                    <div className="max-w-7xl mx-auto">
                        <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
                            What We Source for Your Garage
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                            {[
                                {
                                    title: "Workshop Equipment",
                                    desc: "From lifts and diagnostic tools to everyday essentials—fully equipped solutions for your garage.",
                                    image: "https://m.media-amazon.com/images/I/71qtmKu0wcL._AC_SL1500_.jpg",
                                },
                                {
                                    title: "OEM & Aftermarket Parts",
                                    desc: "Engines, radiators, brakes, and more—sourced directly from trusted suppliers across the UK.",
                                    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ960qHzIGj154jpFmvAlUaN7Pa2tmTEMaluQ&s",
                                },
                                {
                                    title: "Consumables & Tools",
                                    desc: "Everything from lubricants to torque wrenches—keeping your garage running without delays.",
                                    image: "https://m.media-amazon.com/images/I/61LRLDZGDEL._AC_SL1000_.jpg",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className="bg-white rounded shadow p-6 hover:shadow-md"
                                >
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="mx-auto mb-4 h-32 object-contain" />
                                    <h4 className="font-semibold text-xl mb-2 text-blue-800">
                                        {item.title}
                                    </h4>
                                    <p className="text-gray-600 text-sm">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Specialist Sourcing Section */}
                <section
                    className="bg-cover bg-center bg-no-repeat text-white py-20 px-6"
                    style={{
                        backgroundImage: "url('https://static1.hotcarsimages.com/wordpress/wp-content/uploads/2022/12/gt500-engine.jpeg')",
                    }}
                >
                    <div className="bg-black bg-opacity-60 py-12 px-4 md:px-8 rounded">
                        <div className="max-w-7xl mx-auto text-center">
                            <h2 className="text-4xl md:text-5xl font-bold mb-4">
                                Specialist Sourcing for Engines & Major Components
                            </h2>
                            <p className="text-lg max-w-3xl mx-auto">
                                Whether it’s high-performance engines, transmissions, or rare
                                parts, MM AutoTech ensures garages across the UK get the right
                                components, on time and at competitive rates.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Core Automotive Parts Section */}
                <section className="bg-gray-50 py-12 px-6">
                    <div className="max-w-7xl mx-auto">
                        <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
                            Core Automotive Parts We Procure
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                            {[
                                {
                                    name: "Engines & Blocks",
                                    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ960qHzIGj154jpFmvAlUaN7Pa2tmTEMaluQ&s",
                                },
                                {
                                    name: "Transmission",
                                    img: "https://hips.hearstapps.com/hmg-prod/amv-prod-cad-assets/images/09q4/301206/zfs-8-speed-automatic-transmission-photo-315799-s-original.jpg?resize=1200:*",
                                },
                                {
                                    name: "Exhaust Systems",
                                    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQitR4p0hYwxBZfLETYkVckzmV4z_ojDrv1yg&s",
                                },
                                {
                                    name: "Cylinder Heads",
                                    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Oj9X7VW1SRTvIkh5rUQ_Gz4BPAeh96BSYg&s",
                                },
                                {
                                    name: "Cooling Systems",
                                    img: "https://4.imimg.com/data4/DB/RG/MY-10679754/car-radiator.jpg",
                                },
                                {
                                    name: "Mounts & Fittings",
                                    img: "https://m.media-amazon.com/images/I/61juw0cmEOL._AC_SL1500_.jpg",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className="bg-white p-4 rounded shadow hover:shadow-md"
                                >
                                    <img
                                        src={item.img}
                                        alt={item.name}
                                        className="w-full h-32 object-contain mb-2" />
                                    <p className="font-semibold text-blue-900">{item.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Wheels, Tyres & Accessories Section */}
                <section className="bg-white py-12 px-6">
                    <div className="max-w-7xl mx-auto">
                        <h3 className="text-3xl font-bold text-blue-900 mb-6 text-center">
                            Wheels, Tyres & Accessories
                        </h3>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                            {[
                                {
                                    title: "Tyres",
                                    img: "https://www.asdatyres.co.uk/assets/img/homepage/new_tyres.jpg",
                                },
                                {
                                    title: "Premium Rims",
                                    img: "https://m.media-amazon.com/images/I/71xzujvyjPL.jpg",
                                },
                                {
                                    title: "Wheel Spacers",
                                    img: "https://unpluggedperformance.com/wp-content/smush-webp/2023/12/Tesla-Cybertruck-UP-INVINCIBLE%C2%AE-Wheel-Spacers-50mm-1200px-2-1000x1000.jpg.webp",
                                },
                                {
                                    title: "Wheel Hubs",
                                    img: "https://5.imimg.com/data5/SI/SU/CL/SELLER-28240178/wheel-hub-500x500.jpg",
                                },
                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className="bg-gray-50 p-4 rounded shadow hover:shadow-md"
                                >
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        className="w-full h-28 object-contain mb-2" />
                                    <p className="font-semibold text-gray-800">{item.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Why Choose Us Section */}
                <section className="bg-blue-50 py-16 px-6">
                    <div className="max-w-7xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-blue-900 mb-8">
                            Why Choose MM AutoTech?
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {[
                                { title: "OEM Quality", desc: "Only genuine & premium-grade parts." },
                                { title: "Affordable Pricing", desc: "Competitive rates to boost your margins." },
                                { title: "Fast Delivery", desc: "Nationwide next-day availability." },
                                { title: "Trusted Suppliers", desc: "Direct links to global manufacturers." },
                                { title: "Dedicated Support", desc: "Expert team assisting garages daily." },
                                { title: "Wide Network", desc: "From small garages to fleet operators." },
                            ].map((item, idx) => (
                                <div key={idx} className="bg-white shadow rounded-lg p-6 hover:shadow-md">
                                    <h4 className="font-bold text-blue-800 mb-2">{item.title}</h4>
                                    <p className="text-gray-600">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Procurement Process Section */}
                <section className="bg-gray-100 py-16 px-6">
                    <div className="max-w-5xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-blue-900 mb-10">
                            Our Procurement Process
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
                            {["Inquiry", "Quotation", "Sourcing", "Delivery", "Support"].map(
                                (step, idx) => (
                                    <div key={idx} className="bg-white p-6 rounded shadow hover:shadow-md">
                                        <div className="text-2xl font-bold text-yellow-500 mb-2">
                                            {idx + 1}
                                        </div>
                                        <h4 className="font-semibold text-blue-900">{step}</h4>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </section>

                {/* Who We Serve Section */}
                <section className="bg-white py-16 px-6">
                    <div className="max-w-7xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-blue-900 mb-8">
                            Who We Serve
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                            {[
                                "Independent Garages",
                                "Dealerships",
                                "Fleet Operators",
                                "Body Shops",
                            ].map((client, idx) => (
                                <div
                                    key={idx}
                                    className="bg-gray-50 p-6 rounded shadow hover:shadow-md"
                                >
                                    <p className="font-semibold text-blue-800">{client}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Testimonials Section */}
                <section className="bg-blue-100 py-16 px-6">
                    <div className="max-w-6xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-blue-900 mb-10">
                            What Our Clients Say
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {[
                                {
                                    name: "John, Garage Owner",
                                    feedback: "MM AutoTech saved us time and money. Parts arrived next day and fit perfectly.",
                                },
                                {
                                    name: "Sarah, Fleet Manager",
                                    feedback: "They streamlined our procurement process and improved our efficiency massively.",
                                },
                                {
                                    name: "David, Dealer",
                                    feedback: "High-quality OEM parts at affordable prices. Their team is highly responsive.",
                                },
                            ].map((review, idx) => (
                                <div
                                    key={idx}
                                    className="bg-white p-6 rounded shadow hover:shadow-md"
                                >
                                    <p className="text-gray-700 italic mb-4">"{review.feedback}"</p>
                                    <p className="font-semibold text-blue-900">- {review.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Logistics & Delivery Section */}
                <section className="bg-gray-50 py-16 px-6">
                    <div className="max-w-5xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-blue-900 mb-6">
                            Fast & Reliable Delivery
                        </h2>
                        <p className="text-gray-700 max-w-2xl mx-auto mb-8">
                            We offer UK-wide logistics support with next-day delivery on most
                            parts. From single components to bulk orders, our network ensures
                            your garage never stops running.
                        </p>
                        <img
                            src="https://www.shutterstock.com/image-photo/outside-logistics-distributions-warehouse-diverse-600nw-2042952425.jpg"
                            alt="Logistics Delivery"
                            className="mx-auto h-56 object-contain" />
                    </div>
                </section>

                {/* FAQ Section */}
                <section className="max-w-7xl mx-auto px-4">
                    <FAQSection data={PartsProcurementFAQs} />
                </section>

                {/* CTA Section */}
                <section className="py-16 bg-[#0f172a] text-white px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden">
                    <div className="max-w-3xl mx-auto">
                        <h2 className="text-4xl font-bold mb-6">
                            Ready to Source Affordable, Quality Parts?
                        </h2>
                        <p className="mb-8 text-lg">
                            Contact MM AutoTech today and streamline your garage’s procurement
                            process.
                        </p>
                        <Link
                            to="/contact"
                            className="inline-block bg-yellow-400 text-blue-900 font-semibold px-8 py-3 rounded shadow hover:bg-yellow-300"
                        >
                            Request a Quote Now
                        </Link>
                    </div>
                </section>

                {/* Suppliers Section */}
                <section className="bg-gray-50 text-center py-20">
                    <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-12">
                        Our Parts Suppliers
                    </h2>
                    <div className="overflow-hidden">
                        <div className="flex animate-scroll whitespace-nowrap w-max gap-20 px-6">
                            {[...supplierLogos, ...supplierLogos].map((logo, index) => (
                                <a
                                    key={`logo-${index}`}
                                    href={logo.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block"
                                >
                                    <img
                                        src={logo.src}
                                        alt={logo.alt}
                                        className="h-32 w-auto object-contain transition duration-300 hover:scale-105" />
                                </a>
                            ))}
                        </div>
                    </div>
                </section>
            </div></>
    );
};

export default PartsProcurement;
